import React from 'react';
import { PricingHero } from '../components/pricing/PricingHero';
import { PricingTable } from '../components/pricing/PricingTable';
import { CTASection } from '../components/CTASection';
export function Pricing() {
  return <>
      <PricingHero data-id="element-333" data-mp="40wqpbsl1l94" />
      <PricingTable data-id="element-334" data-mp="40ekpng4bso0" />
      <CTASection data-id="element-335" data-mp="3v8skcs0cjuvo" />
    </>;
}